import React from 'react';
import {
    Box,
    Grid,
    Typography,
    TextField,
    Button,
    CircularProgress,
    Paper
} from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

import { t } from 'i18next';
import { useStressTest } from '../../../../hooks/useStressTest';
import { MainCard } from 'component/cards/MainCard2';

const SectionCard = ({ title, children }) => (
    <Paper
        sx={{
            p: 2,
            mb: 2,
            borderRadius: 2,
            border: '1px solid #ddd'
        }}
    >
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
            {title}
        </Typography>
        {children}
    </Paper>
);

const ViewMedicalTestPage = () => {
    const { uuid } = useParams();
    const navigate = useNavigate();

    const { data: test, isLoading, error } = useStressTest(uuid);

    if (isLoading || !test) {
        return (
            <Box display="flex" justifyContent="center" mt={4}>
                <CircularProgress />
            </Box>
        );
    }

    const { identification, generalData, clinicalInfo } = test.data || {};
    const file = test.files?.[0];

    return (
        <MainCard title={t('stress.title2')}>
            <Grid size={12}>
                <Grid size={12}>
                    <SectionCard title={t('stress.identification')}>
                        {/* IDENTIFICAÇÃO */}
                        <Grid container spacing={2}>
                            {Object.entries(identification || {}).map(([key, value]) => (
                                <Grid item xs={12} md={4} key={key}>
                                    <TextField
                                        fullWidth
                                        label={key}
                                        value={value ?? ''}
                                        disabled
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </SectionCard>
                </Grid>

                {/* DADOS GERAIS */}
                <Grid size={12}>
                    <SectionCard title={t('stress.data')}>
                        <Grid container spacing={2}>
                            {Object.entries(generalData || {}).map(([key, value]) => (
                                <Grid item xs={12} md={4} key={key}>
                                    <TextField
                                        fullWidth
                                        label={key}
                                        value={value ?? ''}
                                        disabled
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </SectionCard>
                </Grid>

                {/* INFORMAÇÃO CLÍNICA */}
                <Grid size={12}>
                    <SectionCard title={t('stress.info')}>
                        <TextField
                            fullWidth
                            multiline
                            minRows={3}
                            value={clinicalInfo ?? ''}
                            disabled
                        />
                    </SectionCard>
                </Grid>

                {/* EXAME / PDF */}
                <Grid size={12}>
                    <SectionCard title={t('stress.exam')}>
                        {file ? (
                            <Button
                                variant="contained"
                                startIcon={<PictureAsPdfIcon />}
                                onClick={() => window.open(file.url, '_blank')}
                            >
                                {t('stress.seePDF')}
                            </Button>
                        ) : (
                            <Typography color="text.secondary">
                                {t('stress.noPDF')}
                            </Typography>
                        )}
                    </SectionCard>
                </Grid>

                {/* AÇÕES */}
                <Grid
                    size={12}
                    sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}
                >
                    <Button sx={{ mr: 2 }} onClick={() => navigate(-1)}>
                        {t('stress.back')}
                    </Button>
                </Grid>
            </Grid>
        </MainCard>
    );
};

export default ViewMedicalTestPage;
